import { local } from 'wix-storage'; import wixData from 'wix-data';
import wixWindow from 'wix-window'; import {fetch} from 'wix-fetch';  
import {loadState} from 'backend/searchState.jsw'; import {search} from 'backend/searchState.jsw'; import {countResults} from 'backend/searchState.jsw';
import {getLink} from 'backend/searchName.jsw'; 
import {numberWithCommas} from 'backend/random.jsw'; import {formatNumberInput} from 'backend/random.jsw';

let lastFilterTitle;
let debounceTimer;
let rowsCount;
let riaData;
let searchResultsArray;
let checkBoxValues = [];
let loadItems = 5;
let loadMore = false;


$w.onReady(async function () 
{
    loadRepeater(); filterView();

    let options = await loadState();
    $w("#dropdown1").options = options;
// $w('#repeater1').data = riaData;    
    if (wixWindow.formFactor === "Desktop")
    {
        $w("#seeResults").collapse();
        $w("#transparentFilterButton").collapse();
        $w("#FilterButton").collapse(); $w("#image2").collapse(); $w("#text57").collapse();
    }
    
});
export async function loadRepeater()
{
//riaData = await getData();
    await $w("#repeater1").onItemReady(($item, itemData, index) =>
    {
        $w('#repeater1').show();
        $w("#dropdown1").enable();
        $w("#dropdown1").style.borderColor = "#e21c21";
        $item("#repeaterTitle").text = itemData.name;
        let aum = nFormatter(itemData.aum, 1);//itemData.aum.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        $item("#repeaterAUM").text ="$"+ aum;
        let years = itemData.years; years = years.toString(); $item("#repeaterYears").text = years;
        $item("#repeaterAvg").text = "$"+itemData.investment.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        let percent = 100*itemData.focus;
        $item("#repeaterFocus").text = parseFloat(percent).toFixed(0)+"%";
        let disc = itemData.disclosures;
        $item("#repeaterDisclosures").text = disc;
        //$item("#repeaterZip").text = itemData.zip;
        $item("#repeaterZip").text = itemData.mainOfficeCity + ", " + itemData.mainState; 
        $item("#repeaterStatus").text = itemData.status;
        let offices = itemData.offices; offices = offices.toString(); $item("#repeaterOffices").text = offices;
        //let fullLink = "https://www.financefriends.org/investmentadvisors/"+itemData.crd;
        $item("#repeaterButton").link = itemData.link;
        $item("#repeaterButton").target = "_blank";
        $item("#repeaterRatings").rating = itemData.rating;
        $item("#repeaterRatings").numRatings = itemData.count;


        if (disc === "Yes")
        {
            $item("#repeaterDisclosures").html = "<p style='font-size: 16px; font-style: janna; text-align: right; color: #FF0000;'>" + disc + "</p>";
        }

        // let crd = itemData.crd;
        // wixData.query("writeAReviewStats").eq("crd", crd).find().then((results)=>{
        //     if(results.items.length > 0)
        //     {
        //         let firstItem = results.items[0];
        //         let ratingInput = firstItem.rating/firstItem.count;
        //         $item("#repeaterRatings").rating = ratingInput;
        //         $item("#repeaterRatings").numRatings = firstItem.count;
                

        //     }else
        //     {
        //         $item("#repeaterRatings").collapse();
        //     }
        // })
    })
   
    // if ($w('#repeaterDisclosures').text ==="Yes")
    // {
    //      $w("#repeaterDisclosures").text.style.color =  "#e21c21";
    // }
}

//building the filters for the RIA table
export async function filterView() 
{
    if (loadMore !== true)
    {
        $w('#repeater1').data = [];$w('#repeater1').collapse(); 
        $w('#resultsNumber').hide(); $w("#loadMore").hide();
    }
     
    checkBoxValues = []; // pass all the checkbox values in one array
    checkBoxValues = checkBoxValues.concat($w("#checkBox1").value);
    checkBoxValues = checkBoxValues.concat($w("#checkBox2").value);
    checkBoxValues = checkBoxValues.concat($w("#checkBox3").value);
    checkBoxValues = checkBoxValues.concat($w("#checkBox4").value);
    checkBoxValues = checkBoxValues.concat($w("#checkBox5").value);

    //let searchInput = $w("#searchBar").value;
    var assetsFilterMin = $w("#assetsMin").value;
    var assetsFilterMax = $w("#assetsMax").value;
    var avgFilterMin = $w("#avgMin").value;
    var avgFilterMax = $w("#avgMax").value;
    var yearsFilterMin =$w("#yearsMin").value;
    var yearsFilterMax = $w("#yearsMax").value;
    let request = 
    {
        search: "", 
        state: $w("#dropdown1").value, 
        zip: $w("#zipInput").value, radius: $w('#milesInput').value,
        assetsMin: assetsFilterMin, assetsMax: assetsFilterMax,
        yearsMin: yearsFilterMin, yearsMax: yearsFilterMax,
        avgMin: avgFilterMin, avgMax: avgFilterMax,
        officesMin: $w("#officesMin").value, officesMax: $w("#officesMax").value,
        sort: $w("#sortDropdown").value
    }
    // if (loadItems !== lastLoadItems)
    // {lastLoadItems = lastLoadItems+4;}
    // else
    // {$w('#repeater1').data = [];}
    let res;
    await countResults(request, checkBoxValues).then((results)=>{   
        console.log("Count results: " + results);
        res = results;
        res = res.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        $w("#resultsNumber").text = res;
    })
	await search(request, loadItems, checkBoxValues).then((results) => 
    {
        let queryResultsLength = results.length;
		if (queryResultsLength > 0)
		{
            loadRepeater(); $w("#loadMore").show();
			$w("#repeater1").data = results; 
            $w('#repeater1').expand(); $w('#resultsNumber').show();
            $w("#errorMessage").hide();
            console.log(request)
		}else if (queryResultsLength === 0)
        {
            $w("#errorMessage").hide();
            $w("#errorMessage").text = "No results, search options are too narrow.";
            $w("#errorMessage").show();
        }
	})
    
    // let num;
    // num = await countResults(request, checkBoxValues);
    // $w("#resultsNumber").text = num
    // console.log(num);
    // num = formatNumberInput(num);
    // $w("#resultsNumber").text = num;
}

/*
    //reset the dropdown with an option (All) in the dropdown data
    if (stateFilter === "All") {
        stateFilter = "";
    }
    if (cityFilter === "All") {
        cityFilter = "";
    }

    
    let morethanXindividualclients = 1; // placeholder the number of individual clients 
    //filtering for checked boxes 
    $w("#checkBox1").value.forEach((selectedItem) => {
        dataFilter = dataFilter.eq(selectedItem, "Yes")
    })
    $w("#checkBox2").value.forEach((selectedItem) => {
        if (selectedItem === "sortTotalInd") {
            dataFilter = dataFilter.ge(selectedItem, morethanXindividualclients)
        } else { dataFilter = dataFilter.eq(selectedItem, "Yes") }

    })
    $w("#checkBox3").value.forEach((selectedItem) => {
        dataFilter = dataFilter.eq(selectedItem, "Yes")
    })
    $w("#checkBox4").value.forEach((selectedItem) => {
        dataFilter = dataFilter.eq(selectedItem, "Yes")
    })
    $w("#checkBox5").value.forEach((selectedItem) => {
        dataFilter = dataFilter.eq(selectedItem, "No") // asking about if they have disciplinary action = no 
    })

    dataFilter = dataFilter.contains("mainState", stateFilter).or(dataFilter.contains("registrationRegion", stateFilter))
        .or(dataFilter.eq("registrationRegion", "All US States and Territories"));

    $w("#maxData").setFilter(dataFilter)
        .then(() => { // after filter runs, then run the no count results and no results functions
            countResults();
            noResults();
            let count = $w("#maxData").getTotalCount();
            $w("#text77").text = numberWithCommas(count);

        })
        */
export async function loadMore_click(event) 
{
    $w("#dotLoader").expand();
    loadMore = true;
	loadItems = loadItems+5;
    // let scrollX;
    // let scrollY;

    // wixWindow.getBoundingRect().then((windowSizeInfo)=>
    // {
    //     scrollX = windowSizeInfo.scroll.x;        
    //     scrollY = windowSizeInfo.scroll.y;
    // })
    await filterView();
    $w("#dotLoader").collapse();
    // wixWindow.scrollTo(scrollX, scrollY);
   
}

//mobile shit
// there is a transparent box on top of the filters button on mobile because I cannot run functions on grouped objects
export function transparentFilterButton_click(event) 
{
    if ($w("#box1").collapsed) {
        $w("#box1").expand();
    } else {
        $w("#box1").collapse();
    }
}

export function closeFilterBox_click(event) 
{
    filterView();
    $w("#box1").collapse();
    wixWindow.scrollTo(0, 0)
}

export function seeResults_click(event) // if see results button is clicked, return to top of page (filter runs on any change)
{
    filterView();
    $w("#box1").collapse();
    wixWindow.scrollTo(0, 0)
}

export function resetButton_click(event) 
{
    //$w("#searchBar").value = "";
    $w("#dropdown1").value = "";
    //$w("#dropdown2").value = "";
    $w("#zipInput").value = "";
    $w("#milesInput").value = "";
    $w("#assetsMin").value = "";
    $w("#assetsMax").value = "";
    $w("#yearsMin").value = "";
    $w("#yearsMax").value = "";
    $w("#avgMin").value = "";
    $w("#avgMax").value = "";

    $w("#checkBox1").value = [""];
    $w("#checkBox2").value = [""];

    filterView();
}
export function seeResultsButton_click(event) {
    filterView();
}

export function dropdown2_change(event) {}
export function checkBoxes_change(event) {}
export function searchButton_click(event) {}


function vectorImage1_click(event) 
{
	filterView();
}
/*
    export function sortDropdown_change(event) 
    {
    
    searchResultsArray = searchResultsArray.sort((a, b) => a.name.localeCompare(b.name)) 
        $w("#repeater1").data = searchResultsArray
    }
*/

export function sortDropdown_change(event) {
   filterView();
}
export function dropdown1_change(event) {
    $w("#noStateEntry").collapse(); 
    filterView();
}
export function checkBox1_change(event) {
    filterView();
}
export function checkBox2_change(event) {
    filterView();
}
export function checkBox3_change(event) {
    filterView();
}
export function checkBox4_change(event) {
    filterView();
}
export function checkBox5_change(event) {
   filterView();
}
export function milesInput_change(event) 
{
    if ($w("#milesInput").value !== "" && ($w("#zipInput").value !== ""))
        {
            filterView();
            $w('#errorMessage').hide()
        }
        else if ($w("#milesInput").value === "" && ($w("#zipInput").value === ""))
        {
            filterView();
            $w('#errorMessage').hide()
        } else{$w('#errorMessage').text = "Zip code and miles inputs both need to be empty or filled."; setTimeout($w('#errorMessage').show(), 3500)}
}
export function zipInput_change(event) 
{
   if ($w("#milesInput").value !== "" && ($w("#zipInput").value !== ""))
        {
            filterView();
            $w('#errorMessage').hide()
        }
        else if ($w("#milesInput").value === "" && ($w("#zipInput").value === ""))
        {
            filterView();
            $w('#errorMessage').hide()
        }else{$w('#errorMessage').text = "Zip code and miles inputs both need to be empty or filled.";}
}
export function officesMax_change(event) 
{
   filterView();
}
export function officesMin_change(event) {
    filterView()
}
export function assetsMax_change(event) {
    filterView()
}
export function assetsMin_change(event) {
    filterView()
}
export function yearsMax_change(event) {
    filterView()
}
export function yearsMin_change(event) {
    filterView()
}
export function avgMax_change(event) {
    filterView()
}
export function avgMin_change(event) {
    filterView()
}	 

export function button1_click(event) {
	if ($w("#box1").collapsed)
    {
        $w("#box1").expand();
        $w("#generalArrowUp").show();
        $w("#generalArrowDown").hide();
    }
    else if (!$w("#box1").collapsed)
    {
        $w("#box1").collapse()
        $w("#generalArrowUp").hide();
        $w("#generalArrowDown").show();
    }
   filterView()

}

export function text455_click(event) 
{
	if ($w("#box1").collapsed)
    {
        $w("#box1").expand();
        $w("#generalArrowUp").show();
        $w("#generalArrowDown").hide();
    }
    else if (!$w("#box1").collapsed)
    {
        $w("#box1").collapse()
        $w("#generalArrowUp").hide();
        $w("#generalArrowDown").show();
    }
filterView()

}

export function button3_click(event) 
{
	filterView();
    
    if (wixWindow.formFactor === "Mobile")
    {
        if ($w("#box1").collapsed)
        {
            $w("#box1").expand();
        }else {$w("#box1").collapse();}
    }

}

//plus and minus expand or collapse
    export function plusOrX (box, plus, x)
    {
        if (box.collapsed)
        {
            plus.hide();
            x.show();
            box.expand();

        }else{
            plus.show();
            x.hide();
            box.collapse();
            }
    }

    export function step1X_click(event) 
    {plusOrX($w("#noStateEntry"),$w("#step1Plus") , $w("#step1X"));}

    export function step1Plus_click(event) 
    {plusOrX($w("#noStateEntry"),$w("#step1Plus") , $w("#step1X"))}

    export function step2X_click(event) 
    {plusOrX($w("#step2Text"),$w("#step2Plus") , $w("#step2X"));}

    export function step2Plus_click(event) 
    {plusOrX($w("#step2Text"),$w("#step2Plus") , $w("#step2X"))}

    export function step3X_click(event) 
    {plusOrX($w("#step3Text"),$w("#step3Plus") , $w("#step3X")) }

    export function step3Plus_click(event) 
    {plusOrX($w("#step3Text"),$w("#step3Plus") , $w("#step3X")) }

    export function headerX_click(event) 
    {plusOrX($w("#headerText"),$w("#headerPlus") , $w("#headerX"))}

    export function headerPlus_click(event) 
    {plusOrX($w("#headerText"),$w("#headerPlus") , $w("#headerX"))}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */


/**
*	Adds an event handler that runs when an element is displayed
 in the viewable part of the current window.
*	 @param {$w.Event} event
*/
export function box1_viewportEnter(event) {
	 if (wixWindow.formFactor === "Mobile")
    {
        $w('#repeater1').collapse();
    }
}
export function nFormatter(num, digits) {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "B" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" }
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup.slice().reverse().find(function(item) {
    return num >= item.value;
  });
  return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
}

/**
 *	Adds an event handler that runs when the element is clicked.
 *	 @param {$w.MouseEvent} event
 */
export function button4_click(event) 
{
    let name; let CRD; let average; let phone;
    let data = event.context.itemId;
    wixData.get("mininvestmentadvisers", data).then((results)=>{
        let item = results;
        console.log(results);
        name = results.primaryBusinessName;
        average = results.averageInvestment;
        CRD = results.crdNumber;
        phone = results.mainOfficeTelephoneNumber;
    }).then(()=>{
         wixWindow.openLightbox("Send Message", {name: name, average: average, CRD: CRD, phone: phone})
    })
}